import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_BUS006_Request,
  IAPI_BUS006_Response,
} from "../../../type/apiType";

// 配置換えチェック
const httpAPI_BUS006 = async (
  param: IAPI_BUS006_Request
): Promise<IAPI_BUS006_Response> => {
  let res = await http.post(ApiUrl.API_BUS006, {
    ...param,
  });

  return res.data;
};

export { httpAPI_BUS006 };
